<script lang="ts">
	//UI
	import { Card, DeleteIcon, InlineButton } from "@hitit/new_ui/src";
	//Utils
	import { createEventDispatcher } from "svelte";
	//Types
	//Props
	export let editmode = false;

	export let documentState = "";
	export let displaySort = 0;
	export let question = "";
	export let id = "";
	//Constants
	const dispatch = createEventDispatcher();
	//Variables
	//Functions
	function itemClickHandler(id: string) {
		dispatch("ITEM_CLICK", id);
	}
	function itemDeleteHandler(id: string) {
		dispatch("ITEM_DELETE", id);
	}
	//Do

</script>

<div class="item">
	<Card noPadding>
		<button on:click|stopPropagation={() => itemClickHandler(id)}>
			<div class="container">
				<div class="head">
					{#if editmode}
						<div class="drag" />
					{/if}
					<div
						class="status"
						class:publish={documentState === 'PUBLISHED'}
						class:obsolate={documentState === 'OBSOLETE'} />
					<span class="index"> {displaySort} </span>
				</div>
				<p class="title">{question}</p>
				{#if editmode}
					<div class="delete-box">
						<InlineButton on:click={() => itemDeleteHandler(id)}>
							<span class="delete-icon">
								<DeleteIcon fill={'#f66d6c'} />
							</span>
						</InlineButton>
					</div>
				{/if}
			</div>
		</button>
	</Card>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	button {
		width: 100%;
		background-color: transparent;
		border: none;
		padding: 0;
		&:hover {
			cursor: pointer;
		}
	}
	.container {
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		position: relative;
		padding: 10px;
		gap: 20px;
		color: #46474b;
		width: 100%;
		text-align: left;
		.head {
			display: flex;
			align-items: center;
			gap: 10px;
			width: 100%;

			.status {
				width: 15px;
				height: 15px;
				background-color: #bcbfc3;
				border-radius: 15px;
				&.publish {
					background-color: #44e4ae;
				}

				&.obsolate {
					background-color: #ffce00;
				}
			}
			.index {
				font-weight: 500;
			}

			.drag {
				display: flex;
				flex-direction: column;
				width: 20px;
				height: 15px;
				gap: 5.5px;
				justify-content: center;
				&::before,
				&::after {
					content: "";
					width: 20px;
					height: 1px;
					background-color: #bcbfc3;
				}
			}
		}
		.title {
			font-weight: 200;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.delete-box {
			position: absolute;
			top: 10px;
			right: 10px;
			.delete-icon {
				width: 20px;
				height: 20px;
			}
		}
	}

	@include DesktopSize {
		.container {
			padding: 20px;
			gap: 10px;
			.head {
				width: auto;
				gap: 20px;
				font-size: 1.25rem;
				.drag {
					margin-right: -10px;
				}
			}
			.title {
				flex-grow: 1;
				font-size: 1.25rem;
			}
			.delete-box {
				right: 20px;
				top: 50%;
				transform: translate(0%, -50%);
				.delete-icon {
					width: 26px;
					height: 26.2px;
				}
			}
		}
	}

</style>
